export const environment = {
  production: true,
  applicationId: 'd0314473-b503-4b90-9ffa-a5f56cafaad5',
  redirectUrl: 'https://staging.hr-recruit.fullstackagency.it/callback',
  endpoint: 'https://staging.hr-recruit.fullstackagency.it',
};
